import { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import OosToggle from '../../oos-toggle/OosToggle';
import { useFacetAnalyticsEvent } from '../facet-context';
import StatefulLink, { facetsFilter } from '../../stateful-link/StatefulLink';
import styles from './OutOfStockFilter.module.scss';

const OutOfStockFilter = ({
  showHideOutOfStockFilter,
  outOfStockInfo = {},
}) => {
  const { selected, facetId, trackingId } = outOfStockInfo;

  const triggerAnalyticsEvent = useFacetAnalyticsEvent({
    value: {
      facetName: 'stock availability',
      label: 'show in stock items only',
      selected,
      trackingId,
    },
  });

  const triggerEvents = useCallback(() => {
    triggerAnalyticsEvent();
  }, [selected, trackingId, facetId]);

  const queryOpts = useMemo(() => ({ filter: facetsFilter() }), [facetId]);

  if (!showHideOutOfStockFilter) {
    return '';
  }

  return (
    <Fragment>
      <StatefulLink
        onClick={() => triggerEvents()}
        facetId={facetId}
        query={{ page: undefined }}
        queryOpts={queryOpts}
        className={styles.container}
        data-testid="oos-switch"
        tabIndex={0}
        role="switch"
        aria-checked={!selected}
      >
        <span className={styles.label} data-testid="facets-hide-out-of-stock">
          Out of stock items
        </span>
        <OosToggle checked={!selected} />
      </StatefulLink>
    </Fragment>
  );
};

OutOfStockFilter.propTypes = {
  showHideOutOfStockFilter: PropTypes.bool.isRequired,
};

export default OutOfStockFilter;
